@if (options) {
  <div class="modal-header">
    <div class="modal-title">{{ options.header }}</div>
  </div>
}

@if (options) {
  <div class="app-content app-content--no-scroll">
    <div class="special-scroller">
      @if (options.subHeader) {
        <div class="sub-header">
          {{ options.subHeader }}
        </div>
      }
      @if (options.message) {
        <div class="message" [innerHTML]="options.message"></div>
      }
      <div class="input">
        @if (options.inputLabel) {
          <label>{{ options.inputLabel }}:</label>
        }
        <input [formControl]="formControl">
      </div>
    </div>
    <div class="buttons">
      @if (!options.required) {
        <button class="button-cancel" type="button" mat-button (click)="cancel()">
          {{ options.cancelText }}
        </button>
      }
      <button
        type="button"
        mat-button
        (click)="submit()"
        [ngClass]="{
          'invalid': formControl.invalid,
          'valid': !formControl.invalid
        }"
        [disabled]="formControl.invalid">
        {{ options.submitText }}
      </button>
    </div>
  </div>
}
